export enum PRODUCT_CATEGORY {
  RAW_MATERIAL = 'Raw Materials',
  FINISHED_GOOD = 'Finished Goods',
}
